import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash-es/cloneDeep';

import Group from './Group';
import LudusSymbol from '../../../common/fabric/LudusSymbol';
import variables from '../../../common/variables';

const Symbol = props => {
  const [loaded, setLoaded] = React.useState(false);
  const [groupProps, setGroupProps] = React.useState(null);
  const { params, symbolContent, hyperlink, currentSlideNumber } = props;
  if (symbolContent !== null && !LudusSymbol.isRegistered(params.reference)) {
    LudusSymbol.register(params.reference, '', symbolContent);
  }

  React.useEffect(() => {
    const _groupProps = cloneDeep(props);
    const { params } = _groupProps;

    LudusSymbol.fromObject(params, e => {
      _groupProps.params.objects = e.objects.map(o =>
        o.toObject(variables.propsToSave),
      );
      setGroupProps(_groupProps);
      setLoaded(true);
    });
  }, [props.params]);

  if (!loaded) {
    return null;
  }

  return (
    <Group
      {...groupProps}
      transitionStatus={props.transitionStatus}
      hyperlink={hyperlink}
      currentSlideNumber={currentSlideNumber}
      globalScale={props.globalScale}
      hasSymbolAsParent
    />
  );
};

Symbol.propTypes = {
  style: PropTypes.objectOf(PropTypes.any).isRequired,
  params: PropTypes.objectOf(PropTypes.any).isRequired,
  globalScale: PropTypes.number.isRequired,
  transitionStatus: PropTypes.string.isRequired,
  hyperlink: PropTypes.string,
  symbolContent: PropTypes.objectOf(PropTypes.any),
  windowHasFocus: PropTypes.bool.isRequired,
  currentSlideNumber: PropTypes.number.isRequired,
};
Symbol.defaultProps = {
  hyperlink: null,
  symbolContent: null,
};

export default connect((state, ownProps) => {
  const symbolData = state.slideReducer.symbols.find(
    symbol => symbol.id === ownProps.params.reference,
  );

  const symbolContent =
    typeof symbolData !== 'undefined' ? JSON.parse(symbolData.content) : null;

  return { symbolContent };
})(Symbol);
